// Vuex transaction module actions
import { API } from '@/config';
import { FILL_LIST } from './mutations-types';

export default {
  async getPromotionsData({ commit }) {
    try {
      const response = await API.get('/promotions/getPromotionsData');
      commit(FILL_LIST, response.data.data);
    } catch (err) {
      console.log(err);
    }
  },

};
